<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Fa from 'svelte-fa'
    import { faAngleLeft, faEdit, faPlus, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { Service } from '../../../modules/posApi/services/service'
    import type { CreateServiceDto } from '../../../modules/posApi/services/dto/create-service.dto'
    import type { UpdateServiceDto } from '../../../modules/posApi/services/dto/update-service.dto'
    import dayjs from 'dayjs'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import type { Schedule } from '../../../modules/schedulerApi/schedules/schedule'

    import Zexpand from '../../_common/z/zexpand.svelte'
    import Services from '../services/services.svelte'
    import type { ServiceNested } from '../../../modules/posApi/services/service-nested'
    import NestedService from './nested-service.svelte'

    // ##############################################################################################################

    const entityId = 'serviceId'

    export let form: boolean = false
    export let serviceId: string = null
    let entity: Service = new Service()

    async function editEntity(id: string) {
        try {
            show = true
            entity = new Service()
            entity = await window.api.pos.services.getOne(id)
            entity.services = await window.api.utils.utils.assignServicesFromObject(entity.services)
            if (!entity.schedulers) entity.schedulers = []
            if (!entity.services) entity.services = []
            console.log('package', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newEntity() {
        entity = new Service()
        entity.services = []
        entity.balance = true
        entity.public = true
        entity.scheduleInterval = 0
        entity.schedulers = []
        entity.schedulersOnline = []
        entity.type = 'package'
        step = 2
    }

    async function createEntity() {
        try {
            show = true
            const dto: CreateServiceDto = {
                consulting: false,
                comissionFixed: 0,
                comissionPercentage: 0,
                comissionCosts: 0,
                comissionFixedAttendant: 0,
                comissionPercentageAttendant: 0,
                comissionCostsAttendant: 0,
                name: entity.name,
                duration: 0,
                price: entity.services.reduce((total, item) => (total += item.price * item.quantity), 0),
                costs: 0,
                balance: true,
                type: 'package',
                stock: 0,
                public: false,
                scheduleInterval: 0,
                schedulers: [],
                schedulersOnline: [],
                description: entity.description,
                needResource: false,
                services: entity.services.map((el) => {
                    return {
                        price: el.price || 0,
                        quantity: el.quantity,
                        serviceId: el.serviceId,
                    }
                }),
                documents: [],
                expirationDays: entity.expirationDays,
                blockDuplicity: true,
            }
            entity = await window.api.pos.services.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdateServiceDto = {
                name: entity.name,
                price: entity.services.reduce((total, item) => (total += item.price * item.quantity), 0),
                description: entity.description,
                expirationDays: entity.expirationDays,
                services: entity.services.map((el) => {
                    return {
                        price: el.price || 0,
                        quantity: el.quantity,
                        serviceId: el.serviceId,
                    }
                }),
            }
            await window.api.pos.services.update(entity[entityId], dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity[entityId]) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.pos.services.getAll({ type: 'package' }, 60)
            entities.map((el) => {
                if (!el.schedulers) el.schedulers = []
            })
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Pacotes'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Pacote' }))
        grid.cols.push(new GridCol({ content: 'Criação', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Alteração', type: GridColTypeEnum.datetime }))
        //grid.cols.push(new GridCol({ content: 'Duração', size: 2 }))
        grid.cols.push(new GridCol({ content: 'Valor', size: 2, type: GridColTypeEnum.float_2 }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnPerson = new GridButton({
                callback: () => editEntity(item.serviceId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.name })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.updatedAt })
            //line.slots.push({ content: dayjs(new Date(0, 0, 0, 0, item.duration, 0)).format('HH:mm') })
            line.slots.push({ content: item.price })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.pos.services.remove(entity[entityId])
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1
    let entities: Service[] = []
    let expand = true
    onMount(async () => {
        await loadEntities()
        if (form) {
            expand = false
            if (serviceId) {
                await editEntity(serviceId)
            } else {
                await newEntity()
            }
        }
    })

    let newService = false

    async function newServiceItem() {
        newService = true
    }

    async function serviceAdded(event) {
        entity.services.push(event.detail)
        entity.services = entity.services
        newService = false
    }

    function serviceClosed() {
        newService = false
        entity.services = entity.services.filter((el) => !!el)
    }
</script>

{#if !show}
    {#if step === 1}
        <Content footer={true}>
            <div class="grid-act">
                <div class="spacer" />
                {#if window.store.token.permissions.tools.services.write}
                    <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo pacote</button>
                {/if}
            </div>
            <Zgrid class="mt-3" {grid} />
            <LoadSpinner {show} />
        </Content>
    {/if}
    {#if step === 2}
        <Content footer={true}>
            <div class="grid-act">
                {#if !form}
                    <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
                {/if}
                <div class="spacer" />
                {#if window.store.token.permissions.tools.services.write}
                    {#if !!entity[entityId]}
                        <button class="btn btn-warning" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
                    {/if}
                    <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
                {/if}
            </div>

            <div class="px-3">
                <Zframe class="mt-3" title="Pacote">
                    <div class="grid-form">
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <label for="" class="input-group-text">Nome</label>
                                    <input type="text" bind:value={entity.name} class="form-control" />
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <label for="" class="input-group-text">Descrição</label>
                                    <input type="text" bind:value={entity.description} class="form-control" />
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <label for="" class="input-group-text">Validade</label>
                                    <input type="number" bind:value={entity.expirationDays} class="form-control" />
                                    <label for="" class="input-group-text">dias</label>
                                </div>
                                <div class="text-muted">Prazo para o cliente consumir após a compra.</div>
                            </div>
                        </div>
                    </div>
                </Zframe>

                <Zframe class="mt-3" title="Serviços no pacote">
                    <div class="row mt-2-sm mx-0">
                        <div class="col">
                            {#if entity.services?.length > 0}
                                <div class="grid-head h-mobile">
                                    <div class="row">
                                        <div class="col">Serviço</div>
                                        <div class="col-md-1 text-end">Valor Unit</div>
                                        <div class="col-md-1 text-end">Qtde</div>
                                        <div class="col-md-1 text-end">Total</div>
                                        <div class="col-md-2" />
                                    </div>
                                </div>
                                <div class="grid-body">
                                    {#each entity.services as item}
                                        <NestedService on:cancel={serviceClosed} on:added={serviceClosed} class="py-1 liner" bind:item />
                                    {/each}
                                </div>
                            {/if}
                            <div class="mt-2 mb-2">
                                {#if newService}
                                    <NestedService class="py-1" on:cancel={serviceClosed} on:added={serviceAdded} />
                                {:else}
                                    <div class="add-item">
                                        <button class="btn btn-secondary btn-sm" on:click={newServiceItem}><Fa icon={faPlus} /> Adicionar serviço...</button>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    </div>
                </Zframe>
                {#if !form}
                    <div class="m-bottom-sm" />
                {:else}
                    <div class="mb-3" />
                {/if}
            </div>
        </Content>
    {/if}
{/if}

<style>
    .limit-width {
        max-width: 400px;
    }
</style>
